module.exports = __webpack_public_path__ + "assets/cd1c5da89483df7357d6a91d2bcd2e24.png";